<template>

  <select-org
    :label="label"
    type="Tower Supplier"
    v-model="formData"
    :required="required"
    :placeholder="placeholder"
    :help-text="helpText"
    :no-form="noForm"
    value-key="value"
    :size="size"
    :full-object="fullObject"
    :disabled="disabled"
    @change="updated"
    />

</template>

<script>

import SelectOrg from '@/components/atoms/selects/SelectOrg'

export default {
  name: 'select-tower-supplier',

  components: {
    SelectOrg
  },

  props: {
    label: {
      type: String,
      default: 'Tower Supplier'
    },
    value: {
//      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'default'
    },
    placeholder: {
      type: String,
      default: null
    },
    helpText: {
      type: String,
      default: null
    },
    fullObject: {
      type: Boolean,
      default: true
    },
    noForm: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    updated (val) {

      if (!this.fullObject) {
        this.$emit('input', val.value, val)
        this.$emit('change', val.value, val)
      } else {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    }
  },

  data () {
    return {
      formData: this.value
    }
  }
}
</script>



// WEBPACK FOOTER //
// SelectTowerSupplier.vue?39e6d9e6